import 'core-js/stable';
import 'whatwg-fetch';
import './polyfills';

import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './app';

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
